const BHV_SUBMIT_KEY = 'bhv-newsletter-submitted';
const BHV_SCROLL_KEY = 'bhv-newsletter-scroll';
// Wie lange eine Notiz als frisch gilt. Zehn Minuten reichen auch, wenn zwischendurch
// ein Captcha geloest werden muss.
const BHV_SUBMIT_MAX_AGE = 10 * 60 * 1000;
// BHV: Nach einer Anmeldung soll das Popup ein Jahr lang nicht mehr von selbst kommen.
const BHV_SUBSCRIBED_DAYS = 365;
const BHV_MOBILE_QUERY = '(max-width: 749px)';

function bhvIsChallengePage() {
  return window.location.pathname.indexOf('/challenge') !== -1;
}

// BHV: Notiz ueber das letzte Absenden. Sie haelt Zeitpunkt, Herkunft und die eingetragene
// Adresse fest. Herkunft: 'popup' und 'footer' werden unterschiedlich behandelt, weil das
// Formular im Footer seine Bestaetigung selbst anzeigt. Adresse: damit die Bestaetigung auch
// nach einer Captcha-Umleitung sagen kann, in welches Postfach die Mail gegangen ist.
function bhvWriteSubmitNote(source, email) {
  try {
    sessionStorage.setItem(
      BHV_SUBMIT_KEY,
      JSON.stringify({ t: Date.now(), s: source, e: email || '' })
    );
  } catch (e) {}
}

function bhvReadSubmitNote() {
  let raw = null;
  try {
    raw = sessionStorage.getItem(BHV_SUBMIT_KEY);
  } catch (e) {}
  if (raw === null) return null;

  let note = null;
  try {
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === 'object') note = parsed;
  } catch (e) {
    const time = parseInt(raw, 10);
    if (time) note = { t: time, s: 'popup', e: '' };
  }
  if (!note || !note.t) {
    bhvClearSubmitNote();
    return null;
  }

  const age = Date.now() - note.t;
  if (age < 0 || age >= BHV_SUBMIT_MAX_AGE) {
    bhvClearSubmitNote();
    return null;
  }
  return note;
}

function bhvClearSubmitNote() {
  try {
    sessionStorage.removeItem(BHV_SUBMIT_KEY);
  } catch (e) {}
}

function bhvFormEmail(form) {
  if (!form) return '';
  const field = form.querySelector('input[name="contact[email]"]');
  if (!field || !field.value) return '';
  return field.value.trim().slice(0, 120);
}

// BHV: Beim Absenden laedt Shopify die Seite neu, und zwar von oben. Egal ob die Anmeldung aus
// dem Popup oder aus dem Footer kam, die Leserin verliert dabei die Stelle, an der sie stand.
// Deshalb merken wir uns Scrollstand und Seitenpfad vor dem Absenden und stellen sie nach dem
// Neuladen wieder her, sofern wir wirklich auf derselben Seite gelandet sind.
function bhvRememberScroll() {
  try {
    sessionStorage.setItem(
      BHV_SCROLL_KEY,
      JSON.stringify({
        t: Date.now(),
        y: Math.round(window.scrollY || window.pageYOffset || 0),
        p: window.location.pathname
      })
    );
  } catch (e) {}
}

function bhvRestoreScroll() {
  let raw = null;
  try {
    raw = sessionStorage.getItem(BHV_SCROLL_KEY);
    if (raw !== null) sessionStorage.removeItem(BHV_SCROLL_KEY);
  } catch (e) {}

  // Ohne gemerkte Position wissen wir nicht, wo die Leserin stand, also fassen wir den
  // Scrollstand nicht an.
  if (raw === null) return;

  let state = null;
  try {
    state = JSON.parse(raw);
  } catch (e) {}
  if (!state || !state.t) return;
  if (Date.now() - state.t >= BHV_SUBMIT_MAX_AGE) return;

  // Andere Seite als beim Absenden, etwa nach einer Captcha-Umleitung auf die Startseite:
  // dann ist die alte Hoehe sinnlos, wir bleiben oben.
  const target =
    state.p === window.location.pathname ? parseInt(state.y, 10) || 0 : 0;

  window.scrollTo(0, target);
  window.requestAnimationFrame(() => window.scrollTo(0, target));
}

function bhvIsMobile() {
  return !!(window.matchMedia && window.matchMedia(BHV_MOBILE_QUERY).matches);
}

// BHV: Shopifys Cookie-Banner. Solange er sichtbar ist, wartet das Popup, damit nicht zwei
// Ebenen gleichzeitig ueber der Seite liegen.
function bhvConsentBannerVisible() {
  const banner =
    document.getElementById('shopify-pc__banner') ||
    document.querySelector('.shopify-pc__banner__dialog');
  if (!banner) return false;
  const style = window.getComputedStyle(banner);
  if (style.display === 'none' || style.visibility === 'hidden') return false;
  const rect = banner.getBoundingClientRect();
  return rect.width > 0 && rect.height > 0;
}

// BHV: Wer ueber einen Newsletter-Link kommt, ist schon angemeldet und bekommt kein Popup.
function bhvCameFromEmail() {
  try {
    const params = new URLSearchParams(window.location.search);
    const medium = (params.get('utm_medium') || '').toLowerCase();
    return medium === 'email' || medium === 'e-mail' || medium === 'newsletter';
  } catch (e) {
    return false;
  }
}

function bhvScrollDepth() {
  const doc = document.documentElement;
  const scrollable = Math.max(doc.scrollHeight - window.innerHeight, 0);
  // Kaum scrollbare Seite: dann zaehlt sie als gelesen.
  if (scrollable < window.innerHeight * 0.5) return 100;
  const y = window.scrollY || window.pageYOffset || 0;
  return Math.round((y / scrollable) * 100);
}

class NewsletterPopup extends ModalDialog {
  constructor() {
    super();
    this.delay = (parseInt(this.dataset.delay, 10) || 20) * 1000;
    this.scrollNeeded = parseInt(this.dataset.scroll, 10) || 0;
    this.closeDays = parseInt(this.dataset.closeDays, 10) || 14;
    this.autoAllowed = this.dataset.auto !== 'false';
    this.closed = getCookie('newsletter-closed');
    this.subscribed = getCookie('newsletter-subscribed');
    this.form = this.querySelector('.js-form');
    this.ageVerificationPopup = document.querySelector(
      'age-verification-popup'
    );

    if (!!this.form) {
      this.form.addEventListener(
        'submit',
        this.onSubscribe.bind(this)
      );
    }

    const doneButton = this.querySelector('.bhvnl__done');
    if (doneButton) {
      doneButton.addEventListener('click', () => this.hide());
    }

    // BHV: Escape schliesst auch dann, wenn der Fokus gerade nicht im Popup liegt
    // (mobil ist das Bottom-Sheet nicht modal).
    this.onDocumentKeydown = event => {
      if (!this.hasAttribute('open')) return;
      if (event.key === 'Escape' || event.code === 'Escape') this.hide();
    };
  }

  // BHV: Drei Faelle entscheiden, ob das Popup die Bestaetigung zeigt.
  // 1. Fehlermarker im Formular: nichts zeigen, Notiz verwerfen.
  // 2. Serverseitiger Marker vorhanden, also kein Captcha dazwischen: kam die Anmeldung aus
  //    dem Footer, zeigt das Formular dort seine Meldung selbst, dann bleibt das Popup zu.
  // 3. Kein Marker, aber eine frische Notiz: Shopify hat wegen der Spam-Pruefung umgeleitet.
  //    Dann ist das Popup die einzige Stelle, an der die Bestaetigung noch auftauchen kann.
  wasJustSubmitted() {
    if (this.querySelector('.js-newsletter-error')) {
      bhvClearSubmitNote();
      return false;
    }

    const note = bhvReadSubmitNote();

    if (this.querySelector('.js-newsletter-posted')) {
      if (note && note.s === 'footer') {
        bhvClearSubmitNote();
        return false;
      }
      return true;
    }

    return !!note;
  }

  // BHV: Kam die Seite ohne Formularstatus zurueck, weil ein Captcha dazwischen lag, steht das
  // Anmeldefeld noch da und die Bestaetigung fehlt. Dann blenden wir das Formular aus und
  // setzen den Text ein, den die Sektion mitliefert. Die Adresse steht fett darin, damit sie
  // im Satz sofort auffaellt.
  renderClientMessage(note) {
    const formWrapper = this.querySelector('.newsletter-popup__form');
    if (formWrapper) formWrapper.style.display = 'none';

    if (this.querySelector('.newsletter-popup__message')) return;

    const paragraph = document.createElement('p');
    paragraph.className = 'newsletter-popup__message';

    const template = this.dataset.postedMessageEmail;
    if (note && note.e && template && template.indexOf('{email}') !== -1) {
      const parts = template.split('{email}');
      const mail = document.createElement('strong');
      mail.textContent = note.e;
      paragraph.appendChild(document.createTextNode(parts[0]));
      paragraph.appendChild(mail);
      paragraph.appendChild(document.createTextNode(parts[1] || ''));
    } else {
      const text = this.dataset.postedMessage;
      if (!text) return;
      paragraph.textContent = text;
    }

    const spam = this.querySelector('.newsletter-popup__spam');
    if (spam && spam.parentNode) {
      spam.parentNode.insertBefore(paragraph, spam);
    } else if (formWrapper && formWrapper.parentNode) {
      formWrapper.parentNode.insertBefore(paragraph, formWrapper);
    }
  }

  showPostedState() {
    const hasServerMessage = !!this.querySelector('.js-newsletter-posted');
    const note = bhvReadSubmitNote();
    bhvClearSubmitNote();

    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', window.location.pathname);
    }
    bhvRestoreScroll();

    if (!hasServerMessage) this.renderClientMessage(note);

    this.classList.add('newsletter-popup--posted');
    const titlePosted = this.querySelector('.newsletter-popup__title--posted');
    if (titlePosted && titlePosted.id && this.dialogHolder) {
      this.dialogHolder.setAttribute('aria-labelledby', titlePosted.id);
    }
    this.show();
  }

  connectedCallback() {
    // BHV: Auf der Captcha-Seite bleibt das Popup komplett still, auch der Zeitausloeser.
    // Die Anmeldung ist dort noch nicht durch, eine Bestaetigung waere falsch und wuerde
    // ausserdem die Frage nach dem Roboter verdecken.
    if (bhvIsChallengePage()) return;

    // BHV: Diese Pruefung steht bewusst vor der Abfrage auf den Theme-Editor.
    // Im Editor ist Shopify.designMode true, dort wurde der Bestaetigungszustand
    // sonst nie erreicht und die Anmeldung sah aus wie vorher.
    if (this.wasJustSubmitted()) {
      this.showPostedState();
      return;
    }

    if (Shopify.designMode) {
      if (this.dataset.openInDesignMode === 'true') {
        this.show();
      }
      return;
    }

    if (this.ageVerificationPopup) {
      let prevClassState = this.classList.contains(
        'newsletter-popup-is-hidden'
      );

      var newsletterPopup = this;

      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.attributeName == 'class') {
            var currentClassState =
              mutation.target.classList.contains(
                'newsletter-popup-is-hidden'
              );
            if (prevClassState !== currentClassState) {
              prevClassState = currentClassState;
              if (!currentClassState) newsletterPopup.scheduleAutoOpen();
            }
          }
        });
      });
      observer.observe(this, { attributes: true });
    } else {
      this.scheduleAutoOpen();
    }
  }

  // BHV: Das Popup oeffnet sich von selbst erst, wenn
  // 1. die eingestellte Zeit auf der Seite vergangen ist,
  // 2. die Besucherin den eingestellten Anteil der Seite gescrollt hat (kurze Seiten zaehlen als gelesen),
  // 3. kein Cookie-Banner, Warenkorb oder Menue offen ist und das Fenster sichtbar ist.
  // Nie auf Seiten, die die Sektion ausschliesst (data-auto="false"), nicht nach Schliessen
  // (fuer die eingestellte Zahl an Tagen) und nicht nach einer Anmeldung.
  scheduleAutoOpen() {
    if (!this.autoAllowed) return;
    if (this.closed !== null || this.subscribed !== null) return;
    if (bhvCameFromEmail()) return;
    if (this.autoScheduled) return;
    this.autoScheduled = true;

    const start = Date.now();
    let maxDepth = bhvScrollDepth();
    const onScroll = () => {
      const depth = bhvScrollDepth();
      if (depth > maxDepth) maxDepth = depth;
    };
    window.addEventListener('scroll', onScroll, { passive: true });

    const tick = () => {
      if (this.hasAttribute('open')) return cleanup();
      if (getCookie('newsletter-closed') !== null || getCookie('newsletter-subscribed') !== null) {
        return cleanup();
      }
      const timeOk = Date.now() - start >= this.delay;
      const scrollOk = maxDepth >= this.scrollNeeded;
      const pageFree =
        document.visibilityState === 'visible' &&
        !bhvConsentBannerVisible() &&
        !document.body.classList.contains('overflow-hidden') &&
        !document.querySelector('modal-dialog[open], cart-drawer.active, cart-drawer[open], details[open] > .menu-drawer');
      if (timeOk && scrollOk && pageFree) {
        cleanup();
        this.show();
      }
    };
    const timer = window.setInterval(tick, 1000);
    const cleanup = () => {
      window.clearInterval(timer);
      window.removeEventListener('scroll', onScroll);
    };
  }

  // BHV: Mobil ist das Popup ein Bottom-Sheet ohne Abdunkelung. Die Seite bleibt dann
  // scrollbar, deshalb dort keine Scrollsperre und kein aria-modal.
  show(opener) {
    super.show(opener);
    const mobile = bhvIsMobile();
    if (mobile) {
      document.body.classList.remove('overflow-hidden');
      // Nicht modal: Tab darf aus dem Sheet heraus zurueck auf die Seite.
      removeTrapFocus();
    }
    if (this.dialogHolder) {
      this.dialogHolder.setAttribute('aria-modal', mobile ? 'false' : 'true');
    }
    document.addEventListener('keydown', this.onDocumentKeydown);
    // BHV: Das Theme setzt den Fokus im selben Moment, in dem das Popup noch unsichtbar ist
    // (Einblendung ueber visibility), dann geht er verloren. Deshalb kurz danach noch einmal.
    window.setTimeout(() => {
      if (!this.hasAttribute('open') || !this.dialogHolder) return;
      if (this.dialogHolder.contains(document.activeElement)) return;
      this.dialogHolder.focus({ preventScroll: true });
    }, 60);
  }

  hide() {
    super.hide();
    document.removeEventListener('keydown', this.onDocumentKeydown);
    setCookie('newsletter-closed', 'true', this.closeDays);
  }

  onSubscribe() {
    bhvWriteSubmitNote('popup', bhvFormEmail(this.form));
    bhvRememberScroll();
    setCookie('newsletter-subscribed', 'true', BHV_SUBSCRIBED_DAYS);
    this.hide();
  }
}

customElements.define('newsletter-popup', NewsletterPopup);

// BHV: Dieselbe Notiz auch fuer alle Anmeldeformulare ausserhalb des Popups, vor allem das im
// Footer. Ohne sie bleibt eine Anmeldung von dort nach einem Captcha voellig unkommentiert:
// Shopify leitet dann auf die Startseite, und der Footer dort weiss nichts von dem Absenden.
// Der Scrollstand wird hier ebenfalls gemerkt, sonst landet man nach dem Neuladen oben auf der
// Seite, obwohl man gerade unten im Footer stand.
// Ausserdem bekommt das Popup danach ein Jahr Ruhe, die Besucherin ist ja angemeldet.
if (!window.bhvNewsletterSubmitListener) {
  window.bhvNewsletterSubmitListener = true;
  document.addEventListener(
    'submit',
    function (event) {
      const form = event.target;
      if (!form || !form.classList) return;
      if (!form.classList.contains('newsletter-form')) return;
      if (form.closest('newsletter-popup')) return;
      bhvWriteSubmitNote('footer', bhvFormEmail(form));
      bhvRememberScroll();
      try {
        setCookie('newsletter-subscribed', 'true', BHV_SUBSCRIBED_DAYS);
      } catch (e) {}
    },
    true
  );
}

// BHV: Der Scrollstand wird auch dann wiederhergestellt, wenn das Popup geschlossen bleibt.
// Genau das ist der Fall bei einer Anmeldung im Footer ohne Captcha: die Meldung steht dort
// im Formular, und die Leserin soll sie sehen, statt oben auf der Seite zu landen.
if (!bhvIsChallengePage()) {
  bhvRestoreScroll();
}
